import React, {useState, useEffect, useMemo, useCallback} from 'react';
import {myService} from '@app/services/sukienService';
import {alertService} from '@app/services/alertService';
import {useLocation} from 'react-router-dom';
import * as mainService from '@app/services/mainService';
import {Input, Tabs} from "@components";
import {getControllerName, getDefaultSelectValue,renewTrangthai} from '@app/utils/helpers';
import {
    image_root,
    INIT_ROLE_MENU,
    PAGES_SIZE_DEFAULT, SERVER_YYYYMM_FORMAT
} from '@app/const/AppSetting';
import HeaderClick from '@app/utils/HeaderClick';
import Pagination from "@material-ui/lab/Pagination";
import {useDispatch, useSelector} from "react-redux";
import {
    DownloadFile,
    findObjInArr,
    formatCurencyVI,
    formatDateClient,
    getFormData,
    getMenuName,
    isEmpty
} from "@app/utils/CommonFunctions";
import Select, { components } from "react-select";
import {useTranslation} from "react-i18next";
import {Card, HRTag} from "@components";
import {loadMenu} from "@store/reducers/auth";
import {Button, Modal} from "react-bootstrap";
import {saveAs} from 'file-saver';
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {trangthaiSlice} from "@store/reducers/trangthaiSlice";
import CoquanListComponent from '@app/pages/FUtil/CoquanListComponent';
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import NewDataButton from '@app/utils/NewDataButton';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import {ClipLoader} from "react-spinners";
import NhadanListComponent from "@pages/FUtil/NhadanListComponent";
import NhadanchitietEditModal from './NhadanchitietEditModal';
import ImportErrorTable from '@app/pages/FUtil/ImportErrorTable';
import {uploadService} from "@app/services/uploadService";

const SukienNhadanList = ({ history }) => {
    const [t] = useTranslation();
    const pageSizes = PAGES_SIZE_DEFAULT;
    const location = useLocation();
    const currController = getControllerName(location.pathname);
    const dispatch = useDispatch();
    const menu = useSelector((state) => state.auth.menu);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initialSearchItems = {
        coquan_fk: null,
        ten: "",
        nhadan_fk: null,
        trangthai_fk: null,
        searchbyText: ''
    };

    // Import error states
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [importErrors, setImportErrors] = useState([]);
    const [importErrorsTitle, setImportErrorsTitle] = useState('');
    const [importcolumnError, setImportcolumnError] = useState('');

    const [removeToogle, setRemoveToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingTicket, setLoadingTicket] = useState(false);
    const [objs, setObjs] = useState([]);
    const [objAlls, setObjAlls] = useState([]);
    const [searchItems, setSearchItems] = useState({ ...initialSearchItems });
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    const [activeTab, setActiveTab] = useState(0);

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);
    const [parentId, setParentId] = useState('af3eefcde54966b433782ed770f1cf72');

    // Upload state
    const [fileUpload, setFileUpload] = useState(null);

    // Memoized function to prevent unnecessary re-renders
    const storeSearchItems = useCallback((searchItems) => {
        const newMenu = menu.map((elem) => {
            return {
                ...elem,
                children: elem.children.map((item) =>
                    item.path.includes(currController) ? { ...item, searchItems: searchItems } : item,
                ),
            };
        });
        dispatch(loadMenu(newMenu));
    }, [menu, currController, dispatch]);

    // Debounced API call to prevent multiple calls
    const retrieveTutorials = useCallback(async (search) => {
        if (!search) search = searchItems;

        try {
            // Use nhadanchitiet API instead of generic getAll
            const { data, pageinfo } = await myService.getAllNhadanchitiet(page, pageSize, search);
            setObjs(data);
            setObjAlls(data);
            setCount(pageinfo.totalpage);
        } catch (error) {
            console.error('Error retrieving nhadanchitiet:', error);
            alertService.error('Error loading data');
        }
    }, [page, pageSize, searchItems]);

    // Fixed filter change handler
    const onChangeFilter = useCallback(async (e) => {
        const { name, value } = e.target;
        const newSearch = { ...searchItems, [name]: value };

        setSearchItems(newSearch);

        // Only make API call for specific fields
        if (name === 'maChungTu') {
            await retrieveTutorials(newSearch);
        }

        // Store search items for date fields
        if (name === 'tuNgay' || name === 'denNgay') {
            storeSearchItems(newSearch);
        }
    }, [searchItems, retrieveTutorials, storeSearchItems]);

    // File input change handler
    const onchangeInput = async (name, e) => {
        const { files} = e.target;
        setFileUpload(files[0]);
    }

    // Fixed selected change filter
    const onSelectedChangeFilter = useCallback(async (name, e) => {
        setLoadingTicket(true);

        try {
            const newSearch = { ...searchItems, [name]: e ? e.value : '' };
            setSearchItems(newSearch);
            storeSearchItems(newSearch);
            await retrieveTutorials(newSearch);
        } catch (error) {
            console.error('Error in filter change:', error);
        } finally {
            setLoadingTicket(false);
        }
    }, [searchItems, storeSearchItems, retrieveTutorials]);

    const createRs = useCallback(async () => {
        // Your existing createRs logic here
        // setLoading(false); // Remove this if not needed
    }, []);

    const loadTable = useCallback(async () => {
        setLoadingTicket(true);

        try {
            if (!hasRole) {
                const role = await mainService.getRoleMENU(location.pathname);
                setRoleMenu(role);
                setHasRole(true);
            }

            let search = {};
            menu.forEach((elem) => {
                const m = elem.children.find((item) => item.path.includes(currController));
                if (m !== undefined) search = m;
            });

            const searchData = search.searchItems || initialSearchItems;
            setSearchItems(searchData);
            await retrieveTutorials(searchData);

            let divtb1 = document.getElementById("divtb1");
            setActiveTab(divtb1 ? 0 : 1);
        } catch (error) {
            console.error('Error loading table:', error);
        } finally {
            setLoadingTicket(false);
        }
    }, [hasRole, location.pathname, menu, currController, initialSearchItems, retrieveTutorials]);

    // Fixed useEffect - initial load
    useEffect(() => {
        const initializeComponent = async () => {
            try {
                await mainService.checkRole({
                    pathname: location.pathname,
                    isAddMode: false,
                    currController,
                    history
                });
                await createRs();
                setLoading(false);
            } catch (error) {
                console.error('Error initializing component:', error);
                setLoading(false);
            }
        };

        initializeComponent();
    }, []); // Empty dependency array for initial load only

    // Fixed useEffect - data loading
    useEffect(() => {
        const loadData = async () => {
            await createRs();
            await loadTable();
        };

        if (!loading) { // Only load data after initial setup
            loadData();
        }
    }, [removeToogle, page, pageSize, loading]); // Added loading to dependencies

    // Modal handlers
    const handleModalHide = () => {
        setShowModal(false);
        setSelectedObj(null);
        setParentId('af3eefcde54966b433782ed770f1cf72');
    };

    const handleModalSuccess = async () => {
        // Refresh the list after successful create/update
        await retrieveTutorials();
    };

    // Import functionality
    const importClick = async () => {
        if (!fileUpload) {
            alertService.error("Vui lòng chọn file");
            return;
        }

        setLoading(true);
        const form = getFormData({ fileUpload, uploadType: 'SUKIEN_NHADAN_TYPE' });

        try {
            const result = await uploadService.ImportStandard(form);
            if (result) {
                if (result.status === "1") {
                    alertService.success(result.msg);
                    // Refresh the data after successful import
                    await retrieveTutorials();
                    // Clear the file input
                    setFileUpload(null);
                    const fileInput = document.getElementById('fileUpload');
                    if (fileInput) fileInput.value = '';
                } else {
                    // Show dynamic table with error data
                    setImportErrors(result.data || []);
                    setImportErrorsTitle(result.msg || 'Import thất bại')
                    setImportcolumnError(result.data2 || '')
                    setShowErrorModal(true);
                    alertService.error(result.msg || 'Import thất bại');
                }
            } else {
                alertService.error('Có lỗi xảy ra trong quá trình import');
            }
        } catch (error) {
            console.error('Import error:', error);
            alertService.error('Có lỗi xảy ra trong quá trình import');
        } finally {
            setLoading(false);
        }
    };

    const handleAddNew = () => {
        setSelectedObj(null); // null means new record
        setParentId('af3eefcde54966b433782ed770f1cf72'); // Set appropriate parent ID if needed
        setShowModal(true);
    };

    // Rest of your component methods remain the same...
    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    const findByTitle = async () => {
        setLoading(true);
        setPage(1);
        await retrieveTutorials();
        setLoading(false);
    };

    const removeSearch = async () => {
        setPage(1);
        setSearchItems({...initialSearchItems});
        setRemoveToogle((prevSelected) => !prevSelected);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (value.length > 0) {
            const filtered = objAlls.filter(
                item =>
                    (item.nha_dan?.toLowerCase().indexOf(value.toLowerCase().trim()) > -1) ||
                    (item.nhom_su_kien?.toLowerCase().indexOf(value.toLowerCase().trim()) > -1) ||
                    item.id.toString().indexOf(value) > -1
            );
            setObjs(filtered);
        } else {
            setObjs(objAlls);
        }
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const editdonhang = (rowIndex) => {
        setSelectedObj({...objs[rowIndex]});
        setParentId('af3eefcde54966b433782ed770f1cf72'); // Set appropriate parent ID
        setShowModal(true);
    };

    const deletedonhang = async (rowIndex) => {
        const { id } = objs[rowIndex];
        try {
            const result = await myService.Delete_nhadanchitiet(id);
            if (result.status === "1") {
                alertService.success(t('fields.label.xoathanhcong'));
                await retrieveTutorials();
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi xóa dữ liệu');
        }
    };

    const excel = async () => {
        setLoading(true);
        try {
            const result = await myService.excelNhadanchitiet(page, pageSize, searchItems);
            const blob = new Blob([result.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, 'Danh_sach_nhadan_chitiet');
        } catch (error) {
            alertService.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const excelPath = async (action) => {
        setLoading(true);
        try {
            const result = await myService.excelPathNhadanchitiet({...searchItems, uploadType: action});
            if (result.status === "1") {
                await DownloadFile(image_root + result.data, result.data2);
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const viewTable = (
        loadingTicket ?
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div> :
            <div className="card-body table-responsive p-0">
                <table className="table table-hover text-nowrap">
                    <thead>
                    <tr>
                        <th className="text-center">Nhà đàn</th>
                        <th className="text-center">Nhóm sự kiện</th>
                        <th className="text-center">Phân loại sự kiện</th>
                        <th className="text-center">Đốt sở</th>
                        <th className="text-center">Xin keo</th>
                        <th className="text-center">Hình thức</th>
                        <th className="text-center">Kết quả</th>
                        <th className="text-center">Ngày sắc phong</th>
                        <th className="text-center">Tác vụ</th>
                    </tr>
                    </thead>
                    <tbody>
                    {objs && objs.map((item, i) => {
                        let editable = [];

                        if (roleMenu.quyenchinhsua === 1) {
                            editable = [
                                ...editable,
                                <a
                                    className="btn btn-warning btn-sm mr-2"
                                    key={`edit-nhadanchitiet-${i}`}
                                    title={t('action.label.edit')}
                                    onClick={() => editdonhang(i)}
                                >
                                    <i className="fas fa-pencil-alt" />
                                </a>,
                            ];
                        }

                        if (roleMenu.quyenxoa === 1) {
                            editable = [
                                ...editable,
                                <a
                                    className="btn btn-danger btn-sm mr-2"
                                    key={`delete-nhadanchitiet-${i}`}
                                    title={t('action.label.delete')}
                                    onClick={() => {
                                        if (window.confirm(t('fields.label.bancomuonxoa')))
                                            deletedonhang(i);
                                    }}
                                >
                                    <i className="fas fa-times-circle" />
                                </a>,
                            ];
                        }

                        return (
                            item && (
                                <tr key={`item-nhadanchitiet-${i}`}>
                                    <td className="text-center">{item.nha_dan}</td>
                                    <td className="text-center">{item.nhom_su_kien}</td>
                                    <td className="text-center">{item.phan_loai_su_kien}</td>
                                    <td className="text-center">{item.trang_thai_dot_so}</td>
                                    <td className="text-center">{item.trang_thai_xin_keo}</td>
                                    <td className="text-center">{item.hinh_thuc}</td>
                                    <td className="text-center">{item.trang_thai_ket_qua}</td>
                                    <td className="text-center">{item.ngay_sac_phong}</td>
                                    <td className="text-center">{editable}</td>
                                </tr>
                            )
                        );
                    })}
                    </tbody>
                </table>
            </div>
    );

    return (
        <div className="card card-primary">
            <HeaderClick
                isIndex
                headerName={roleMenu.tenmenu}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <Card title={t('fields.label.boloctimkiem')} isDefaultActive>
                    <div className="card-body">
                        <div className="form-row small">
                            <div className="form-group-sm col-sm-2">
                                <TrangthaiListComponent
                                    trangthai_fk={searchItems.trangthai_fk}
                                    onChange={(e) => onSelectedChangeFilter('trangthai_fk', e)}
                                    filterIds={[0, 1]}
                                    trangthaiName="name"
                                />
                            </div>
                            <div className="form-group-sm col-sm-4">
                                <NhadanListComponent
                                    nhadan_fk={searchItems.nhadan_fk}
                                    onChange={(e) => onSelectedChangeFilter('nhadan_fk', e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <button className="btn btn-dark mr-1" type="button" onClick={removeSearch}>
                            <i className="fa fa-undo"></i>
                        </button>
                        <Button type="button" className="btn btn-primary mr-1" onClick={excel}>
                            <i className="fa fa-file-excel"> Excel</i>
                        </Button>
                        {roleMenu.quyentaomoi === 1 && (
                            <Button type="button" className="btn btn-success mr-1" onClick={handleAddNew}>
                                <i className="fa fa-plus"> Thêm mới</i>
                            </Button>
                        )}
                        {roleMenu.quyentaomoi === 1 && (
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="required" htmlFor="fileUpload">Import dữ liệu</label>
                                    <div className="input-group">
                                        <input
                                            id='fileUpload'
                                            name="fileUpload"
                                            type="file"
                                            className="form-control mr-1"
                                            onChange={(e) => onchangeInput('fileUpload', e)}
                                        />
                                        <Button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={importClick}
                                        >
                                            <i className="fa fa-plus"></i> Upload
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Card>

                <HRTag title={t('fields.label.ketqua') + ' - ' + t('fields.label.list')}/>

                <div className="border-4 border-gray-400 rounded-md p-2">
                    {viewTable}
                </div>

                <div className="mt-3">
                    {t('footer.itemperpage')}
                    <select onChange={handlePageSizeChange} value={pageSize}>
                        {pageSizes.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>

                    <Pagination
                        className="my-3"
                        count={count}
                        page={page}
                        siblingCount={1}
                        boundaryCount={1}
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePageChange}
                    />
                </div>
            </div>

            {/* NhadanchitietEditModal Integration */}
            <NhadanchitietEditModal
                showModal={showModal}
                initialObj={selectedObj}
                allowEdit={roleMenu.quyenchinhsua === 1}
                onHide={handleModalHide}
                onSuccess={handleModalSuccess}
                parentId={parentId}
            />

            {/* Import Error Modal */}
            <ImportErrorTable
                columnError={importcolumnError}
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                data={importErrors}
                title={importErrorsTitle}
                column
            />
        </div>
    );
};

export default SukienNhadanList;